export default {
      id: "i-info-advantages-04-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/sprite.svg#i-info-advantages-04",
      toString: function () {
        return this.url;
      }
    }